import signAquarius from 'assets/signs_reskin/sign_aquarius.svg';
import signAries from 'assets/signs_reskin/sign_aries.svg';
import signCancer from 'assets/signs_reskin/sign_cancer.svg';
import signCapricorn from 'assets/signs_reskin/sign_capricorn.svg';
import signGemini from 'assets/signs_reskin/sign_gemini.svg';
import signLeo from 'assets/signs_reskin/sign_leo.svg';
import signLibra from 'assets/signs_reskin/sign_libra.svg';
import signPisces from 'assets/signs_reskin/sign_pisces.svg';
import signSagittarius from 'assets/signs_reskin/sign_sagittarius.svg';
import signScorpio from 'assets/signs_reskin/sign_scorpio.svg';
import signTaurus from 'assets/signs_reskin/sign_taurus.svg';
import signVirgo from 'assets/signs_reskin/sign_virgo.svg';

import signAquariusStars from 'assets/signs_reskin_stars/sign_aquarius.svg';
import signAriesStars from 'assets/signs_reskin_stars/sign_aries.svg';
import signCancerStars from 'assets/signs_reskin_stars/sign_cancer.svg';
import signCapricornStars from 'assets/signs_reskin_stars/sign_capricorn.svg';
import signGeminiStars from 'assets/signs_reskin_stars/sign_gemini.svg';
import signLeoStars from 'assets/signs_reskin_stars/sign_leo.svg';
import signLibraStars from 'assets/signs_reskin_stars/sign_libra.svg';
import signPiscesStars from 'assets/signs_reskin_stars/sign_pisces.svg';
import signSagittariusStars from 'assets/signs_reskin_stars/sign_sagittarius.svg';
import signScorpioStars from 'assets/signs_reskin_stars/sign_scorpio.svg';
import signTaurusStars from 'assets/signs_reskin_stars/sign_taurus.svg';
import signVirgoStars from 'assets/signs_reskin_stars/sign_virgo.svg';

const SIGN_MAPPING = {
  aries: {
    date: `Mar 21 - Apr 19`,
    defaultImage: signAries,
    starImage: signAriesStars,
    color: `#db2937`,
  },
  taurus: {
    date: `Apr 20 - May 20`,
    defaultImage: signTaurus,
    starImage: signTaurusStars,
    color: `#e97630`,
  },
  gemini: {
    date: `May 21 - Jun 20`,
    defaultImage: signGemini,
    starImage: signGeminiStars,
    color: `#eb9918`,
  },
  cancer: {
    date: `Jun 21 - Jul 22`,
    defaultImage: signCancer,
    starImage: signCancerStars,
    color: `#ebd335`,
  },
  leo: {
    date: `Jul 23 - Aug 22`,
    defaultImage: signLeo,
    starImage: signLeoStars,
    color: `#a1d927`,
  },
  virgo: {
    date: `Aug 23 - Sep 22`,
    defaultImage: signVirgo,
    starImage: signVirgoStars,
    color: `#3bb62e`,
  },
  libra: {
    date: `Sep 23 - Oct 22`,
    defaultImage: signLibra,
    starImage: signLibraStars,
    color: `#40b88e`,
  },
  scorpio: {
    date: `Oct 23 - Nov 21`,
    defaultImage: signScorpio,
    starImage: signScorpioStars,
    color: `#40b2d8`,
  },
  sagittarius: {
    date: `Nov 22 - Dec 21`,
    defaultImage: signSagittarius,
    starImage: signSagittariusStars,
    color: `#4356a2`,
  },
  capricorn: {
    date: `Dec 22 - Jan 19`,
    defaultImage: signCapricorn,
    starImage: signCapricornStars,
    color: `#8c44ca`,
  },
  aquarius: {
    date: `Jan 20 - Feb 18`,
    defaultImage: signAquarius,
    starImage: signAquariusStars,
    color: `#e42ede`,
  },
  pisces: {
    date: `Feb 19 - Mar 20`,
    defaultImage: signPisces,
    starImage: signPiscesStars,
    color: `#ef297d`,
  },
};

const DEFAULT_SIGN_DATA = { date: ``, image: signAries };

export {
  DEFAULT_SIGN_DATA,
  SIGN_MAPPING,
};
